import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOGO_URL = "https://customer-assets.emergentagent.com/job_cf82e0fe-468c-4a43-97a9-405e8da70dca/artifacts/znleb4a2_260207%20Logo%20Galeries%20Yess5zw.png";

export default function HouseRulesPage() {
  const navigate = useNavigate();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await fetch(`${API_URL}/api/content/house-rules`);
      if (response.ok) {
        const data = await response.json();
        setContent(data);
      } else {
        setError('Failed to load content');
      }
    } catch (err) {
      setError('Failed to load content');
      console.error('Error fetching house rules:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#F8E8E0] flex items-center justify-center">
        <div className="animate-pulse text-[#8B7355]">Loading...</div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="min-h-screen bg-[#F8E8E0] flex items-center justify-center">
        <div className="text-[#8B7355]">Unable to load content</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F8E8E0]" data-testid="house-rules-page">
      {/* Header */}
      <div className="sticky top-0 bg-[#F8E8E0] z-10 border-b border-[#E8D5C5]">
        <div className="flex items-center justify-between px-4 py-3">
          <button 
            onClick={() => navigate(-1)} 
            className="p-2 -ml-2"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5 text-[#2D2D2D]" />
          </button>
          <img 
            src={LOGO_URL} 
            alt="Galeries Yess" 
            className="h-8"
          />
          <div className="w-9"></div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-8 pb-24 max-w-2xl mx-auto">
        {/* Title */}
        <h1 className="font-heading text-3xl text-center text-[#2D2D2D] mb-2">
          House Rules
        </h1>
        <p className="text-center text-[#8B7355] italic mb-10">
          {content.intro_text}
        </p>

        {/* Rules */}
        <div className="space-y-8">
          {content.rules && content.rules.map((rule, index) => (
            <div key={index} className="border-b border-[#E8D5C5] pb-6 last:border-0">
              <h2 className="font-heading text-lg text-[#2D2D2D] mb-3">
                {rule.title}
              </h2>
              <div className="text-[#4A4A4A] leading-relaxed whitespace-pre-line">
                {rule.content}
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        {content.footer_text && (
          <div className="mt-12 text-center">
            <p className="text-[#8B7355] italic">
              {content.footer_text}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
